import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  Modal,
  FormControl,
  Alert,
  InputGroup,
  Form,
  Spinner,
  Card,
} from "react-bootstrap";
import "./style.css";
import TBLPedidos from "../../components/TBLPedidos";
import DetalhesPedido from "./DetalhesPedido";
import TBLSeparadores from "../../components/TBLSeparadores";
import * as moment from "moment";
import Select from "react-select";
import "moment/locale/pt-br";
import { BuscarPedidoPorCodigo } from "../../providers/BuscaProvider";
import {
  despacharSeparadorSelecionado,
  listarPedidosPorStatus,
  atualizarStatusPedido,
  cancelarPedidoApi,
  GetMetricasPedidos,
  AlterarPedido,
} from "../../providers/PedidoProvider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import { adiantarDataAgendamento } from "../../services/functions";
import { ListarEntregadores } from "../../providers/EntregadorProvider";
import { listarSeparadores } from "../../providers/SeparadorProvider";

const STATUS_PEDIDO = [
  {
    label: "Criado",
    value: "criado",
  },
  {
    label: "Recebido",
    value: "recebido",
  },
  {
    label: "Em Separacao",
    value: "em_separacao",
  },
  {
    label: "Separado",
    value: "separado",
  },
  {
    label: "Liberado",
    value: "liberado",
  },
  {
    label: "Chegou",
    value: "chegou",
  },
  {
    label: "Entregue",
    value: "entregue",
  },
  {
    label: "Entrega Finalizada",
    value: "entrega_finalizada",
  },
  {
    label: "Agendado",
    value: "agendado",
  },
];

export default class Principal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModalItens: false,
      showModalDespacho: false,
      showModalCancelarPedido: false,
      row: null,
      showAlert: null,
      data: [],
      separadores: [],
      pesquisa: "",
      pages: 1,
      page: 1,
      limit: 10,
      loading: false,
      justificativaCancelamento: "",
      erroJustificativa: false,
      loadingMetricas: false,
      pedidos_agendados: 0,
      pedidos_andamento: 0,
      qtd_pedidos_finalizados: 0,
      total_faturamento: 0,
      total_faturamento_hoje: 0,
      pedidos_cancelados: 0,
      pedidos_cancelados_hoje: 0,
      pedidos_finalizados_hoje: 0,
      pedidos_agendados_hoje: 0,
      pedidos_status: [],
      status_atual: "",
      entregadores: [],
      entregadores_formatados: [],
      showModalPedidosStatus: false,
      showModalAlteracao: false,
      status_pedidos: STATUS_PEDIDO,
      page_status: 1,
      pages_status: 1,
      loading_status: true,
      entregador_selecionado: null,
      separador_selecionado: null,
    };
    moment.locale("pt-BR");
  }

  handleCloseModalItens = () => {
    this.setState({ showModalItens: false });
  };

  handleShowModalItens = () => {
    this.setState({ showModalItens: true });
  };

  handleCloseModalDespacho = () => {
    this.setState({ showModalDespacho: false });
  };

  handleShowModalDespacho = () => {
    this.setState({ showModalDespacho: true });
  };

  handleCloseModalCancelarPedido = () => {
    this.setState({ showModalCancelarPedido: false });
  };

  handleShowModalCancelarPedido = () => {
    this.setState({ showModalCancelarPedido: true });
  };

  despacharSeparador = async (id_pedido, id_separador) => {
    const response = await despacharSeparadorSelecionado(id_pedido, id_separador);
    if (response.success) {
      toast.success("Separador despachado com sucesso!");
    }
  };

  alterarStatusPedido = async () => {
    try {
      if (this.state.row && this.state.status_selecionado) {
        if (
          (this.state.status_selecionado.value == "entregue" ||
            this.state.status_selecionado.value == "entrega_finalizada") &&
          !this.state.entregador_selecionado
        ) {
          toast.error("Selecione ou altere o entregador antes");
          return;
        }
        const id = this.state.row._id;
        const response = await AlterarPedido(id, {
          status: this.state.status_selecionado.value,
        });
        if (response) {
          await this.getPedidosEmAndamento();
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  getEntregadores = async () => {
    const list = await ListarEntregadores();
    this.setState({
      entregadores_formatados: list.map((e) => ({
        label: e.nome,
        value: e._id,
      })),
      entregadores: list,
    });
    this.setState({
      entregadores_formatados: [
        { label: "Nenhum Entregador", value: null },
        ...this.state.entregadores_formatados,
      ],
    });
  };

  alterarEntregadorPedido = async () => {
    try {
      if (this.state.row && this.state.entregador_selecionado) {
        const id = this.state.row._id;
        const response = await AlterarPedido(id, {
          entregador: this.state.entregador_selecionado.value,
        });
        if (response) {
          await this.getPedidosEmAndamento();
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  alterarSeparadorPedido = async () => {
    try {
      if (this.state.row && this.state.entregador_selecionado) {
        const id = this.state.row._id;
        const response = await AlterarPedido(id, {
          separador: this.state.separador_selecionado.value,
        });
        if (response) {
          await this.getPedidosEmAndamento();
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  salverAlteracoes = async () => {
    try {
      await this.alterarStatusPedido();
      await this.alterarEntregadorPedido();
      await this.alterarSeparadorPedido();
      this.setState({
        status_selecionado: null,
        entregador_selecionado: null,
        separador_selecionado: null,
        showModalAlteracao: false,
      });
      toast.success("Alterações salvas com sucesso");
    } catch (error) {
      toast.error("Erro ao realizar alterações");
    }
  };

  recuperarDadosTabela = (tipo, dados) => {
    if (tipo === "ver_itens") {
      this.setState({ row: dados });
      this.handleShowModalItens();
    } else if (tipo === "despachar_separador") {
      this.setState({ row: dados });
      this.handleShowModalDespacho();
    } else if (tipo === "separador_despachado") {
      this.handleCloseModalDespacho();
      this.despacharSeparador(this.state.row._id, dados._id);
    } else if (tipo === "cancelar_pedido") {
      this.setState({ row: dados });
      this.handleShowModalCancelarPedido();
    } else if (tipo === "alterar-pedido") {
      this.setState({
        row: dados,
        showModalAlteracao: true,
        entregador_selecionado: dados.entregador
          ? {
              label: dados.entregador.nome,
              value: dados.entregador._id,
            }
          : null,
        status_selecionado: STATUS_PEDIDO.filter((s) => s.value === dados.status),
      });
    } else {
      return;
    }
  };

  listarSeparadoresDisponiveis = async () => {
    let disponiveis = [];
    const response = await listarSeparadores();
    if (response) {
      response.docs.forEach((sep) => {
        if (sep.status === "disponivel") {
          disponiveis.push(sep);
        }
      });
      this.setState({ separadores: disponiveis });
    }
  };

  pesquisarPedidosPorCodigo = async (pesquisa) => {
    if (pesquisa) {
      const response = await BuscarPedidoPorCodigo(pesquisa);
      this.setState({ data: response });
    } else {
      this.getPedidosEmAndamento();
    }
  };

  getPedidosEmAndamento = async (current_page) => {
    this.setState({ loading: true, loading_status: true });
    const status = [
      "agendado",
      "criado",
      "recebido",
      "em_separacao",
      "separado",
      "liberado",
      "chegou",
    ];
    let { docs, limit, page, pages } = await listarPedidosPorStatus(current_page, status);
    if (docs) {
      for (let pedido of docs) {
        if (pedido.status === "criado") {
          const res = await atualizarStatusPedido(pedido._id, "recebido");
          if (res) {
            pedido.status = "recebido";
          }
        }
        if (pedido.dataAgendamento) {
          pedido.dataAgendamento = adiantarDataAgendamento(pedido);
        }
      }
      this.setState({
        data: docs.sort((a, b) =>
          new Date(a.agendado ? a.dataAgendamento : a.createdAt) <
          new Date(b.agendado ? b.dataAgendamento : b.createdAt)
            ? -1
            : 1,
        ),
        pages,
        page,
        loading: false,
        limit,
        loading_status: false,
      });
    }
  };

  getPedidoPorStatus = async (current_page, status_name, status) => {
    this.setState({ loading_status: true });
    let { docs, page, pages } = await listarPedidosPorStatus(current_page, status);
    for (let pedido of docs) {
      if (pedido.dataAgendamento) {
        pedido.dataAgendamento = adiantarDataAgendamento(pedido);
      }
    }
    if (docs) {
      this.setState({
        pedidos_status:
          status[0] === "agendado"
            ? docs.sort((a, b) =>
                new Date(a.dataAgendamento) < new Date(b.dataAgendamento) ? -1 : 1,
              )
            : docs,
        pages_status: pages,
        page_status: page,
        status_atual: status_name,
        status: status,
        loading_status: false,
      });
    }
  };

  async componentDidMount() {
    await this.getPedidosEmAndamento(1);
    await this.carregarMetricas();
    await this.listarSeparadoresDisponiveis();
    await this.getEntregadores();
    setInterval(async () => {
      await this.getPedidosEmAndamento(this.state.page);
    }, 60000);
    setInterval(async () => {
      await this.carregarMetricas();
    }, 120000);
  }

  carregarMetricas = async () => {
    this.setState({ loadingMetricas: true });
    const metricas = await GetMetricasPedidos();
    if (metricas) {
      let {
        pedidos_agendados,
        pedidos_andamento,
        qtd_pedidos_finalizados,
        total_faturamento,
        pedidos_cancelados,
        pedidos_finalizados_hoje,
        total_faturamento_hoje,
        pedidos_cancelados_hoje,
        pedidos_agendados_hoje,
      } = metricas;
      this.setState({
        pedidos_agendados,
        pedidos_andamento,
        qtd_pedidos_finalizados,
        total_faturamento,
        pedidos_cancelados,
        pedidos_finalizados_hoje,
        total_faturamento_hoje,
        pedidos_cancelados_hoje,
        pedidos_agendados_hoje,
        loadingMetricas: false,
      });
    } else {
      this.setState({
        loadingMetricas: false,
      });
    }
  };

  cancelarPedido = async () => {
    try {
      const pedido = this.state.row;
      if (pedido) {
        if (this.state.justificativaCancelamento) {
          const response = await cancelarPedidoApi(pedido._id, {
            justificativa: this.state.justificativaCancelamento,
            status_pedido: pedido.status,
          });
          if (response && !response.error) {
            this.setState({
              justificativaCancelamento: "",
              erroJustificativa: false,
            });
            toast.success("Pedido cancelado com sucesso!");
            setInterval(() => {
              window.location.reload();
            }, 1000);
          }
        } else {
          this.setState({ erroJustificativa: true });
        }
      }
    } catch (error) {
      toast.error("Não foi possível cancelar o pedido");
    }
  };

  render() {
    return (
      <div>
        <br></br>
        {this.state.showAlert ? (
          <Alert style={{ zIndex: 99999999999 }} variant={this.state.variantAlert}>
            {this.state.mensagemAlert}
          </Alert>
        ) : null}
        <Row>
          <Col>
            <Card bg="warning">
              <Card.Body>
                <Card.Title>Pedidos Em Andamento</Card.Title>
                {this.state.loadingMetricas ? (
                  <Spinner animation="border" size="sm"></Spinner>
                ) : (
                  <div>
                    <Card.Subtitle style={{ fontSize: 26 }}>
                      {this.state.pedidos_andamento}
                    </Card.Subtitle>
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
          <Col>
            <Card bg="info" text="white">
              <Card.Body>
                <Card.Title>Pedidos Agendados</Card.Title>
                {this.state.loadingMetricas ? (
                  <Spinner animation="border" size="sm"></Spinner>
                ) : (
                  <div>
                    <Card.Subtitle style={{ fontSize: 18, marginBottom: 10 }}>
                      Para Hoje: {this.state.pedidos_agendados_hoje}
                    </Card.Subtitle>
                    <Card.Subtitle
                      style={{
                        fontSize: 14,
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <p>Esse Mês: {this.state.pedidos_agendados}</p>
                      <Button
                        size="sm"
                        variant="warning"
                        onClick={() => {
                          this.getPedidoPorStatus(1, "Pedidos Agendados", ["agendado"]);
                          this.setState({ showModalPedidosStatus: true });
                        }}
                      >
                        Ver mais
                      </Button>
                    </Card.Subtitle>
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
          <Col>
            <Card bg="danger" text="white">
              <Card.Body>
                <Card.Title>Pedidos Cancelados</Card.Title>
                {this.state.loadingMetricas ? (
                  <Spinner animation="border" size="sm"></Spinner>
                ) : (
                  <div>
                    <Card.Subtitle style={{ fontSize: 18, marginBottom: 10 }}>
                      Hoje: {this.state.pedidos_cancelados_hoje}
                    </Card.Subtitle>
                    <Card.Subtitle
                      style={{
                        fontSize: 14,
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <p>Esse Mês: {this.state.pedidos_cancelados}</p>
                      <Button
                        size="sm"
                        variant="warning"
                        onClick={() => {
                          this.getPedidoPorStatus(1, "Pedidos Cancelados", ["cancelado"]);
                          this.setState({ showModalPedidosStatus: true });
                        }}
                      >
                        Ver mais
                      </Button>
                    </Card.Subtitle>
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
          <Col>
            <Card bg="primary" text="white">
              <Card.Body>
                <Card.Title>Pedidos Finalizados</Card.Title>
                {this.state.loadingMetricas ? (
                  <Spinner animation="border" size="sm"></Spinner>
                ) : (
                  <div>
                    <Card.Subtitle style={{ fontSize: 18, marginBottom: 10 }}>
                      Hoje: {this.state.pedidos_finalizados_hoje}
                    </Card.Subtitle>
                    <Card.Subtitle
                      style={{
                        fontSize: 14,
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <p>Esse Mês: {this.state.qtd_pedidos_finalizados}</p>
                      <Button
                        size="sm"
                        variant="warning"
                        onClick={() => {
                          this.getPedidoPorStatus(1, "Pedidos Finalizados", [
                            "entregue",
                            "entrega_finalizada",
                          ]);
                          this.setState({ showModalPedidosStatus: true });
                        }}
                      >
                        Ver mais
                      </Button>
                    </Card.Subtitle>
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
          <Col>
            <Card bg="success" text="white">
              <Card.Body>
                <Card.Title>Total Faturado</Card.Title>
                {this.state.loadingMetricas ? (
                  <Spinner animation="border" size="sm"></Spinner>
                ) : (
                  <div>
                    <Card.Subtitle style={{ fontSize: 18, marginBottom: 10 }}>
                      Hoje: R$ {parseFloat(this.state.total_faturamento_hoje).toFixed(2)}
                    </Card.Subtitle>
                    <Card.Subtitle style={{ fontSize: 14 }}>
                      Esse Mês: R$ {parseFloat(this.state.total_faturamento).toFixed(2)}
                    </Card.Subtitle>
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <br></br>
        <Row>
          <Col md={12}>
            <h3>Pedidos em andamento</h3>
          </Col>
        </Row>
        <br></br>
        <div>
          <InputGroup>
            <InputGroup.Prepend>
              <InputGroup.Text>
                <FontAwesomeIcon icon={faSearch}></FontAwesomeIcon>
              </InputGroup.Text>
            </InputGroup.Prepend>
            <FormControl
              placeholder="Pesquisar pedidos por código"
              onChange={(e) => this.pesquisarPedidosPorCodigo(e.target.value)}
            />
          </InputGroup>

          <TBLPedidos
            dataCallback={this.recuperarDadosTabela}
            data={this.state.data}
            getPedidos={() => this.getPedidos(this.state.page)}
            limit={this.state.limit}
            pages={this.state.pages}
            loading={this.state.loading}
            changePage={(p) => this.getPedidos(p)}
          ></TBLPedidos>
        </div>

        <Modal
          size="xl"
          show={this.state.showModalItens}
          onHide={this.handleCloseModalItens}
        >
          <Modal.Header closeButton className="modalHeader">
            <Modal.Title>
              {this.state.row
                ? `Código pedido: ${this.state.row.codigo} - ${this.state.row.status
                    .replace("_", " ")
                    .toUpperCase()}`
                : null}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.row ? (
              <DetalhesPedido pedido={this.state.row}></DetalhesPedido>
            ) : null}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseModalItens}>
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          size="xl"
          show={this.state.showModalDespacho}
          onHide={this.handleCloseModalDespacho}
        >
          <Modal.Header closeButton className="modalHeader">
            <Modal.Title>
              {this.state.row ? `Código pedido: ${this.state.row.codigo}` : null}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4>Selecione o separador a ser despachado: </h4>
            <TBLSeparadores
              data={this.state.separadores}
              isDespacho={true}
              numRows={10}
              dataCallback={this.recuperarDadosTabela}
            ></TBLSeparadores>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseModalDespacho}>
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          size="xl"
          show={this.state.showModalCancelarPedido}
          onHide={this.handleCloseModalCancelarPedido}
        >
          <Modal.Header closeButton className="modalHeader">
            <Modal.Title>
              {this.state.row ? `Código pedido: ${this.state.row.codigo}` : null}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col>
                <Form>
                  <Form.Group>
                    <Form.Label>Digite a justificativa para o Cancelamento:</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows="4"
                      placeholder="Justificativa"
                      onChange={(e) => {
                        this.setState({
                          justificativaCancelamento: e.target.value,
                        });
                      }}
                    />
                    {this.state.erroJustificativa ? (
                      <p style={{ color: "red" }}>
                        Insira uma justificativa para cancelar o pedido
                      </p>
                    ) : null}
                  </Form.Group>
                </Form>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseModalCancelarPedido}>
              Fechar
            </Button>
            <Button onClick={this.cancelarPedido}>Finalizar</Button>
          </Modal.Footer>
        </Modal>
        <Modal
          size="xl"
          show={this.state.showModalPedidosStatus}
          onHide={() =>
            this.setState({
              showModalPedidosStatus: false,
              status_atual: "",
              pedidos_status: [],
              page_status: 1,
            })
          }
        >
          <Modal.Header closeButton className="modalHeader">
            <Modal.Title>{this.state.status_atual}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <TBLPedidos
              dataCallback={this.recuperarDadosTabela}
              data={this.state.pedidos_status}
              getPedidos={() =>
                this.getPedidoPorStatus(
                  this.state.page_status,
                  this.state.status_name,
                  this.state.status,
                )
              }
              loading={this.state.loading_status}
              pages={this.state.pages_status}
              changePage={(p) =>
                this.getPedidoPorStatus(p, this.state.status_name, this.state.status)
              }
            ></TBLPedidos>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() =>
                this.setState({
                  showModalPedidosStatus: false,
                  status_atual: "",
                  pedidos_status: [],
                  page_status: 1,
                })
              }
            >
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          size="lg"
          show={this.state.showModalAlteracao}
          onHide={() =>
            this.setState({
              showModalAlteracao: false,
              entregador_selecionado: null,
              separador_selecionado: null,
              status_selecionado: null,
              row: null,
            })
          }
        >
          <Modal.Header closeButton className="modalHeader">
            <Modal.Title>
              {this.state.row
                ? `Alterar pedido: ${this.state.row.codigo} - ${this.state.row.status
                    .replace("_", " ")
                    .toUpperCase()}`
                : null}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4>Status</h4>
            <Row>
              <Col md={12}>
                <Form.Group>
                  <Select
                    placeholder="Status"
                    value={this.state.status_selecionado}
                    options={this.state.status_pedidos}
                    onChange={(opt) => this.setState({ status_selecionado: opt })}
                    isClearable
                  />
                </Form.Group>
              </Col>
            </Row>
            <h4>Entregador</h4>
            <Row>
              <Col md={12}>
                <Form.Group>
                  <Select
                    placeholder="Entregador"
                    value={this.state.entregador_selecionado}
                    options={this.state.entregadores_formatados}
                    onChange={(opt) => this.setState({ entregador_selecionado: opt })}
                    isClearable
                  />
                </Form.Group>
              </Col>
            </Row>
            <h4>Separador</h4>
            <Row>
              <Col md={12}>
                <Form.Group>
                  <Select
                    placeholder="Separador"
                    value={this.state.separador_selecionado}
                    options={[
                      { label: "Remover Separador", value: null },
                      {
                        label: "Continuar com separador",
                        value: this.state.row?.separador,
                      },
                    ]}
                    onChange={(opt) => this.setState({ separador_selecionado: opt })}
                    isClearable
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Button
                  variant="primary"
                  style={{ marginTop: 10, marginRight: 10 }}
                  onClick={this.salverAlteracoes}
                >
                  Salvar
                </Button>
              </Col>
            </Row>
            <br></br>
            <h4>Cancelar Pedido</h4>
            <Row>
              <Col md={12}>
                <Form.Group>
                  <Form>
                    <Form.Group>
                      <Form.Label>Digite a justificativa para o Cancelamento:</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows="4"
                        placeholder="Justificativa"
                        onChange={(e) => {
                          this.setState({
                            justificativaCancelamento: e.target.value,
                          });
                        }}
                      />
                      {this.state.erroJustificativa ? (
                        <p style={{ color: "red" }}>
                          Insira uma justificativa para cancelar o pedido
                        </p>
                      ) : null}
                    </Form.Group>
                  </Form>
                  <Button
                    variant="danger"
                    style={{ marginTop: 10, marginRight: 10 }}
                    onClick={this.cancelarPedido}
                  >
                    Cancelar
                  </Button>
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() =>
                this.setState({
                  showModalAlteracao: false,
                  entregador_selecionado: null,
                  status_selecionado: null,
                  row: null,
                })
              }
            >
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
